import { useEffect } from 'react';
import {
  SocialActionEnum,
  useControllerSocialMediaContext
} from '../../hooks/ControllerSocialMedia';
import { initApple } from '../../services/socialNetWorkController';
import Icon from '../Icon/Icon';
import './SocialMedia.scss';
import { useAuthContext } from '../../hooks/AuthContext';
import { setCookie } from '../../services/cookieController';
import Button from '../Button/Button';
import {
  handleOAuthRedirectURI,
  isSocialRecoveryFlow,
  pushGtmEvent,
  saveSocialFlowPath
} from '../../utils/GenericFunctions';

interface ButtonAppleProps {
  action?: SocialActionEnum;
  showText?: boolean;
}

export default function ButtonApple({
  action,
  showText = false
}: ButtonAppleProps) {
  const { loginApple } = useControllerSocialMediaContext();
  const { redirectURL } = useAuthContext();

  useEffect(() => {
    initApple();
  }, []);

  return (
    <>
      <div
        style={{ display: 'none' }}
        id="appleid-signin"
        data-color="black"
        data-border="true"
        data-type="sign in"
      ></div>
      <Button
        customColors="btn-neutral"
        id="apple-btn"
        data-testid="btn-apple"
        aria-label="Entrar com Apple"
        onClick={() => {
          handleOAuthRedirectURI('apple', action);
          if (isSocialRecoveryFlow()) {
            pushGtmEvent('recovery_social_click', { provider: 'apple' });
          }
          if (redirectURL) setCookie('redirect', redirectURL);
          saveSocialFlowPath();
          loginApple(action);
        }}
      >
        <Icon className="apple-icon" name="logoApple" />
        {showText && 'Continuar com Apple'}
      </Button>
    </>
  );
}
